import { Link } from "react-router-dom";

export default function TrustBannerSection() {
  return (
    <section className="py-8 md:py-14 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-6 md:gap-12 items-center">
          {/* Image */}
          <div className="w-full lg:w-1/2 h-48 sm:h-72 md:h-96 rounded-2xl overflow-hidden flex-shrink-0">
            <img
              alt="Furgonetas de Persianas Málaga — servicio técnico local en Málaga capital"
              className="w-full h-full object-cover object-center"
              loading="lazy"
              src="/images/vehiculo.webp"
            />
          </div>
          {/* Texte */}
          <div className="flex-1 w-full">
            <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3 md:mb-4 font-heading">
              Tu tranquilidad empieza con una{" "}
              <span className="text-primary-500">persiana que funciona</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-5 md:mb-6 leading-relaxed">
              Servicio técnico local en Málaga capital. Más de 10 años reparando
              persianas, mosquiteras y motorización. Técnicos en plantilla,
              furgoneta propia y recambios en stock.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-600 flex-shrink-0">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-file-list-3-line"></i>
                  </span>
                </div>
                <div>
                  <h3 className="text-sm font-bold text-foreground-900">
                    Presupuesto gratis
                  </h3>
                  <p className="text-xs text-foreground-500">
                    Precio cerrado por escrito. Sin compromiso ni sorpresas.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-400/10 text-accent-500 flex-shrink-0">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-car-line"></i>
                  </span>
                </div>
                <div>
                  <h3 className="text-sm font-bold text-foreground-900">
                    Furgoneta propia
                  </h3>
                  <p className="text-xs text-foreground-500">
                    Técnicos locales con vehículo equipado. Sin subcontratas.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-500/10 text-secondary-600 flex-shrink-0">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-shield-check-line"></i>
                  </span>
                </div>
                <div>
                  <h3 className="text-sm font-bold text-foreground-900">
                    2 años de garantía
                  </h3>
                  <p className="text-xs text-foreground-500">
                    Por escrito. Cubre piezas y mano de obra. Si falla, volvemos.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-600 flex-shrink-0">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-tools-line"></i>
                  </span>
                </div>
                <div>
                  <h3 className="text-sm font-bold text-foreground-900">
                    Todas las marcas
                  </h3>
                  <p className="text-xs text-foreground-500">
                    Somfy, Nice, Gaviota, Gradhermetic... Reparamos cualquiera.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-400/10 text-accent-500 flex-shrink-0">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-timer-flash-line"></i>
                  </span>
                </div>
                <div>
                  <h3 className="text-sm font-bold text-foreground-900">
                    Respuesta 24-48h
                  </h3>
                  <p className="text-xs text-foreground-500">
                    Urgencias el mismo día si llamas antes de las 12:00.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-500/10 text-secondary-600 flex-shrink-0">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-map-pin-2-line"></i>
                  </span>
                </div>
                <div>
                  <h3 className="text-sm font-bold text-foreground-900">
                    16 barrios de Málaga
                  </h3>
                  <p className="text-xs text-foreground-500">
                    Sin coste de desplazamiento en toda Málaga capital.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="tel:+34951120770"
                className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-background-50 font-bold text-sm px-8 py-4 rounded-full transition-all active:scale-[0.98] whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/20"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill"></i>
                </span>
                951 12 07 70
              </a>
              <Link
                to="/contacto"
                className="inline-flex items-center justify-center gap-2 bg-background-50 hover:bg-background-100 text-primary-600 font-semibold text-sm px-8 py-4 rounded-full border border-background-200/60 transition-all whitespace-nowrap cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                Formulario de contacto
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}